import React, { useState, useEffect, useReducer } from 'react';
import DisplayLaptop from '../../components/DisplayLaptop'
import { Spinner, Form, Row, Button, Accordion } from 'react-bootstrap'
import Filter from '../../components/Filter';
import { RenderIf, Break } from '@alanngo/custom-components/dist';
import { filterReducer } from './reducer';
import filterSchema from '../../schema/filter';
import { BUDGET, NAME } from './action';


const FindLaptop = ({ laptops = [] }) => {

  // implement filter
  const [filtered, setFiltered] = useState(laptops)
  const [filter, dispatch] = useReducer(filterReducer, filterSchema)


  // filter criteria
  const laptopFilter = (laptop) =>
  (
    laptop.price <= filter.budget &&
    laptop.ram >= filter.ram &&
    new RegExp(filter.name, "i").test(laptop.name)
  )

  useEffect(() => setFiltered(laptops), [laptops])
  
  return (
    <div align="center">
      <Break />

      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header><div align="right">Too many laptops? Click here to filter</div></Accordion.Header>
          <Accordion.Body>
            <Form as={Row} xs={1} md={2}>
              <Filter
                symbol="💸"
                formType="number"
                placeholder="How much are you willing to spend?"
                setCriteria={(e) => dispatch(BUDGET(e.target.value || filterSchema.budget))}
              />
              <Filter
                symbol="🔍"
                formType="text"
                placeholder="keywords"
                setCriteria={(e) => dispatch(NAME(e.target.value || filterSchema.name))}
              />
            </Form>
            <Break />
            <div align="center">
              <Button
                variant="danger"
                onClick={() => setFiltered(laptops)}>Reset
              </Button>
              <Button
                variant="success"
                onClick={() => setFiltered(laptops.filter(laptopFilter))}>Filter
              </Button>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Break number={2} />
      <RenderIf
        condition={laptops.length > 1}
        fallback=
        {
          <div align="center">
            <Spinner animation="border" variant="danger" />
          </div>
        }>
        <DisplayLaptop laptops={filtered} />
      </RenderIf>
    </div>

  )
}
export default FindLaptop